<!-- 已选产品 -->
<template>
    <el-table class="selected-product-tab" tooltip-effect="dark" :data="productLists" style="width: 100%;" empty-text="还没有选择产品">
      <el-table-column prop="logo" header-align="center" align="center" width="100px" label="产品图片">
        <template slot-scope="scope">
          <img  :src="scope.row.logo" :alt="scope.row.logo" class="tpimg">
        </template>
      </el-table-column>

     <el-table-column prop="name" label="产品名称" min-width="140" show-overflow-tooltip></el-table-column>
   
      <el-table-column prop="purchaseNum" label="购买数量" min-width="100" >
          <template slot-scope="{row,$index}">
              <span v-if="!isEdit">{{ row.purchaseNum }}</span>
              <el-input-number v-else v-model="row.purchaseNum" :min="1" size="small"  :step-strictly="true"  controls-position="right" @change="(val) => handleChangeNum(val, row, 'purchaseNum')" >
              </el-input-number>
          </template>
      </el-table-column>

      <el-table-column prop="purchaseMonth" label="购买时长(月)" min-width="100" >
        <template slot-scope="{row,$index}">
            <span v-if="!isEdit">{{ row.purchaseMonth }}</span>
            <el-input-number v-else v-model="row.purchaseMonth" :min="1" size="small" :step-strictly="true" controls-position="right" @change="handleChangeNum" ></el-input-number>
        </template>
      </el-table-column>

      <el-table-column prop="price" label="单价(元)" min-width="100" show-overflow-tooltip>
         <template slot-scope="scope">
          <span class="price">{{ scope.row.price.toLocaleString() }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="effectivetime" label="启用时间" min-width="130" show-overflow-tooltip v-if="!isEdit">
         <template slot-scope="scope">
          <span>{{ scope.row.effectivetime || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="duetime" label="到期时间" min-width="130" show-overflow-tooltip v-if="!isEdit">
         <template slot-scope="scope">
          <span>{{ scope.row.duetime || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" style="text-algin:center">
        <template slot-scope="scope" >
          <!-- <el-button type="primary" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
          <span class="dnnfont icondelete" @click="handleDel(scope.$index, scope.row)" v-if="isEdit"></span>

          <!-- 续费： TODO： 待联调： renewFlg：0 不可续订 1 可续订  scope.row.renewFlg == 1-->
          <el-tooltip effect="dark" content="续费" placement="top" v-if="scope.row.renewFlg == 1">
            <span class="dnnfont iconclock" @click="handleRenewOrder(scope.$index, scope.row)"></span>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {

    productLists: {
      type: Array,
      default: () => []
    },
    
    // 是否编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
    };
  },

  components: {},

  computed: {
  ...mapGetters({
    userInfo: 'userInfo'
  })
},

  mounted(){
    console.log('this.productLists==', this.productLists)
  },

  methods: {

    handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val)
    },

    handleDel(index,data) {
      console.log("index,data==", index,data)
      this.$emit("del", data)
    },
    
    // 续订
    handleRenewOrder(index, row) {
      this.$emit('renew', row)
    }

  }
}

</script>
<style lang='scss' >
.selected-product-tab {
  .dnnfont {
    cursor: pointer;
    &:hover {
      color: #f66b3d;
    }
  }
  .price {
    color: #EB6264;
  }
}
</style>


// WEBPACK FOOTER //
// SelectedProduct.vue?7b6c470f